module.exports = __webpack_public_path__ + "static/media/21.4e0ac402.gif";